export const reduxStatus = {
  idle: "idle",
  loading: "loading",
  error: "error",
  success: "success",
};
